import { PROFILE_TYPE_TRANSLATION } from './users.constants'

export const getProfileTypeTranslation = (name) =>
  PROFILE_TYPE_TRANSLATION[name] ? PROFILE_TYPE_TRANSLATION[name] : name
